/**
 * @generated SignedSource<<fe3abd1d2507dfda51a8845f3ce4e92a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeSectionLeadSecondaryContentItemContent$data = {
  readonly entityId: string;
  readonly topics: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"followButtonBase">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink">;
  readonly " $fragmentType": "homeSectionLeadSecondaryContentItemContent";
};
export type homeSectionLeadSecondaryContentItemContent$key = {
  readonly " $data"?: homeSectionLeadSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeSectionLeadSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeSectionLeadSecondaryContentItemContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "followButtonBase"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "203eed7749b1b5d74bd407d63638c6f3";

export default node;
